module.exports = __webpack_public_path__ + "img/ic_avatar.ba9920ab.svg";